export const LANGUAGE_COOKIE_NAME = 'NEXT_LOCALE';
/**
 * Mirrors the "picked explicitly" flag the client keeps in localStorage so the
 * server, which cannot read localStorage, resolves the language the same way.
 */
export const LANGUAGE_EXPLICIT_COOKIE_NAME = 'language_explicit';

const ONE_YEAR_SECONDS = 365 * 24 * 60 * 60;

export const writeLanguageCookie = (locale: string): void => {
  writeCookie(LANGUAGE_COOKIE_NAME, locale);
};

export const writeLanguageExplicitCookie = (): void => {
  writeCookie(LANGUAGE_EXPLICIT_COOKIE_NAME, 'true');
};

const writeCookie = (name: string, value: string): void => {
  if (typeof document === 'undefined') return;
  document.cookie = `${name}=${value}; path=/; max-age=${ONE_YEAR_SECONDS}; SameSite=Lax`;
};
